module.exports = __webpack_public_path__ + "assets/webgl/ticket_recto_DE_L0.jpg.07fbc5fd.webp";